import { render } from "./BrokerSearch.vue?vue&type=template&id=1b2eb738&scoped=true"
import script from "./BrokerSearch.vue?vue&type=script&lang=js"
export * from "./BrokerSearch.vue?vue&type=script&lang=js"

import "./BrokerSearch.vue?vue&type=style&index=0&id=1b2eb738&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2eb738"]])

export default __exports__